export default function About() {
  return (
    <section id="nosotros" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        {/* Text */}
        <div>
          <p className="text-teal-600 text-xs font-bold tracking-[0.3em] uppercase mb-3">
            Quiénes somos
          </p>
          <h2 className="text-4xl font-black text-gray-900 mb-2">SOBRE NOSOTROS</h2>
          <div className="w-12 h-1 bg-teal-500 mb-8 rounded-full" />

          <div className="space-y-4 text-gray-600 text-sm leading-relaxed">
            <p>
              Somos una empresa con más de <strong className="text-teal-700">15 años de experiencia</strong> en el
              mercado, comprometida con la entrega de calidad y un servicio excepcional.
            </p>
            <p>
              <strong>INSERCOM</strong> se distingue por proporcionar servicios personalizados y de alta calidad en
              áreas clave como construcción, remodelación y reparación de piscinas e hidromasajes, así como en su
              mantenimiento.
            </p>
            <p>
              Nuestra dedicación se basa en la experiencia acumulada a lo largo de los años, siempre guiados por las
              normas, políticas y procedimientos que rigen este sector.
            </p>
            <p>
              Nuestra misión es diseñar, desarrollar y construir piscinas e hidromasajes según las necesidades
              específicas de nuestros clientes, garantizando resultados de primera calidad y buen gusto. Nos esforzamos
              por ofrecer los mejores productos y equipamiento especializado, contribuyendo así a la mejora de la
              infraestructura y la completa satisfacción de nuestros clientes.
            </p>
          </div>

          <div className="flex gap-8 mt-10">
            {[
              { value: "15+", label: "Años de experiencia" },
              { value: "200+", label: "Proyectos completados" },
              { value: "100%", label: "Clientes satisfechos" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-3xl font-black text-teal-600">{stat.value}</p>
                <p className="text-xs text-gray-500 mt-1 leading-tight">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Image */}
        <div className="relative">
          <div className="rounded-2xl overflow-hidden w-full h-[500px]">
            <img
              src="https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/354ae800-db98-4976-8494-d0826a07ad95_ChatGPT-Image-21-mar-2026-17_32_32.png?v=cbaa2a7c67880d2d6d5886b40a1df835"
              alt="Director INSERCOM"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Accent card */}
          <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white rounded-xl px-6 py-4 shadow-lg">
            <p className="text-3xl font-black">15+</p>
            <p className="text-xs font-semibold tracking-wide">Años en el mercado</p>
          </div>
        </div>
      </div>
    </section>
  );
}
